export const StorageKey = {
    TOKEN: 'token',
    USER: 'user',
    FORM_TYPE: 'form_type'
};

export const DefaultSwrOptions = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
}
export const Role = {
    admin: { name: 'Admin', value: 'admin' },
    user: { name: 'User', value: 'user' }
}

